<app-loader></app-loader>
<router-outlet />

<!-- Idle Dialog Component -->
<app-idle-dialog 
  (stayLoggedIn)="onStayLoggedIn()" 
  (logout)="onLogout()">
</app-idle-dialog>

<app-theme-customizer />
